"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Method = exports.ChainConfirmationLevel = exports.AnchoringStatus = exports.TransactionEvent = exports.ResponseStatus = exports.FailoverStrategy = void 0;
var FailoverStrategy;
(function (FailoverStrategy) {
    FailoverStrategy["AbortOnError"] = "abortOnError";
    FailoverStrategy["TryNextOnError"] = "tryNextOnError";
    FailoverStrategy["SingleEndpoint"] = "singleEndpoint";
    FailoverStrategy["QueryMajority"] = "queryMajority";
})(FailoverStrategy || (exports.FailoverStrategy = FailoverStrategy = {}));
var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Pending"] = "pending";
    ResponseStatus["Confirmed"] = "confirmed";
    ResponseStatus["Rejected"] = "rejected";
    ResponseStatus["Unknown"] = "unknown";
    ResponseStatus["Waiting"] = "waiting";
})(ResponseStatus || (exports.ResponseStatus = ResponseStatus = {}));
var TransactionEvent;
(function (TransactionEvent) {
    TransactionEvent["ClusterAnchoringConfirmation"] = "clusterAnchoringConfirmed";
    TransactionEvent["SystemAnchoringConfirmation"] = "systemAnchoringConfirmed";
    TransactionEvent["DappConfirmed"] = "dappConfirmed";
    TransactionEvent["DappReceived"] = "dappReceived";
    TransactionEvent["Signed"] = "signed";
    TransactionEvent["Rejected"] = "rejected";
})(TransactionEvent || (exports.TransactionEvent = TransactionEvent = {}));
var AnchoringStatus;
(function (AnchoringStatus) {
    AnchoringStatus["NotAnchored"] = "notAnchored";
    AnchoringStatus["ClusterAnchored"] = "clusterAnchored";
    AnchoringStatus["SystemAnchored"] = "systemAnchored";
    AnchoringStatus["FailedAnchoring"] = "failedAnchoring";
})(AnchoringStatus || (exports.AnchoringStatus = AnchoringStatus = {}));
var ChainConfirmationLevel;
(function (ChainConfirmationLevel) {
    ChainConfirmationLevel["None"] = "none";
    ChainConfirmationLevel["Dapp"] = "dapp";
    ChainConfirmationLevel["ClusterAnchoring"] = "clusterAnchoring";
    ChainConfirmationLevel["SystemAnchoring"] = "systemAnchoring";
    ChainConfirmationLevel["EvmNetwork"] = "evmNetwork";
})(ChainConfirmationLevel || (exports.ChainConfirmationLevel = ChainConfirmationLevel = {}));
var Method;
(function (Method) {
    Method["GET"] = "get";
    Method["POST"] = "post";
})(Method || (exports.Method = Method = {}));
//# sourceMappingURL=enums.js.map